import { __rest } from 'tslib';
import React, { useReducer, useRef, useEffect, useState, useContext } from 'react';
import { s as styled } from './styled-112a8bd0.js';
import { P as Popper } from './Popper-e22bb0de.js';

const initialState = {
    referenceElement: null,
    toggle: () => { },
    isOpen: false,
    toggleType: '',
};
const DropdownContext = React.createContext(initialState);
const DropdownProvider = ({ children, value }) => {
    const [state, dispatch] = useReducer((state = initialState, action) => {
        switch (action.type) {
            case 'SET_REFERENCE':
                return Object.assign(Object.assign({}, state), { referenceElement: action.payload });
            default:
                return state;
        }
    }, initialState);
    return (React.createElement(DropdownContext.Provider, { value: { state: Object.assign(Object.assign({}, state), value), dispatch } }, children));
};

const DropdownWrapper = styled.div `
  width: 100%;
`;
const Dropdown = (_a) => {
    var { children, isOpen, toggle, toggleType = 'click', className, onHide } = _a, props = __rest(_a, ["children", "isOpen", "toggle", "toggleType", "className", "onHide"]);
    const wrapperRef = useRef(null);
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                toggle();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [wrapperRef, isOpen]);
    return (React.createElement(DropdownProvider, { value: { isOpen, toggle, toggleType } },
        React.createElement(DropdownWrapper, Object.assign({ onMouseEnter: toggleType === 'hover' ? toggle : null, onMouseLeave: toggleType === 'hover' ? onHide : null, className: className, ref: wrapperRef }, props), children)));
};

const StyledDiv$1 = styled.div `
  width: 100%;
  &:focus {
    outline: none;
  }
`;
const DropdownToggle = ({ children, className, }) => {
    const [anchor, setAnchor] = useState(null);
    const { state: { toggle, toggleType }, dispatch, } = useContext(DropdownContext);
    useEffect(() => {
        dispatch({ type: 'SET_REFERENCE', payload: anchor });
    }, [anchor]);
    return (React.createElement(StyledDiv$1, { className: className, ref: setAnchor, onClick: toggleType === 'click' ? toggle : null, onKeyUp: toggleType === 'click' ? toggle : null, tabIndex: 0 }, children));
};

const StyledDiv = styled.div(({ show, origin }) => `
    background-color: transparent;
    // transition: transform 0.2s, opacity 0.2s;
    // transform: scale(${show ? 1 : 0});
    // transform-origin: ${origin};
    opacity: ${show ? 1 : 0};
  `);
const StyledPopper = styled(Popper)(({ show }) => `
    visibility: ${show ? 'visible' : 'hidden'};
    z-index: 999;
  `);
const DropdownMenu = ({ children, popperConfig, placement = 'bottom-start', origin = 'center top', className, }) => {
    const { state: { isOpen, referenceElement }, } = useContext(DropdownContext);
    return (React.createElement(StyledPopper, { className: className, referenceElement: referenceElement, popperConfig: popperConfig, placement: placement, show: isOpen },
        React.createElement(StyledDiv, { show: isOpen, origin: origin }, children)));
};

export { Dropdown as D, DropdownToggle as a, DropdownMenu as b, DropdownContext as c, DropdownProvider as d };
